import { Injectable, inject } from '@angular/core';

import { AuthService, Session } from 'app/providers/bridge-api/auth.service';
import { GroupService } from 'app/providers/semantria-api/group.service';

import { SpotlightAgentSsoService } from './spotlight-agent-sso.service';

interface AgentSessionContext {
  session: Session;
  baseUrl: string;
}

type AgentRequestContext = AgentSessionContext & {
  env: string;
};

/**
 * Shared utilities for Spotlight agent services.
 */
@Injectable()
export abstract class SpotlightAgentBaseService {
  protected readonly authService: AuthService = inject(AuthService);
  protected readonly groupService: GroupService = inject(GroupService);
  protected readonly ssoService: SpotlightAgentSsoService = inject(SpotlightAgentSsoService);

  protected async getAgentSessionContext(): Promise<AgentSessionContext> {
    const session: Session = await this.authService.getSession();
    const baseUrl: string = this.ssoService.getAgentBaseUrl();
    return { session, baseUrl };
  }

  protected async getAgentRequestContext(): Promise<AgentRequestContext> {
    const sessionContext: AgentSessionContext = await this.getAgentSessionContext();
    const env: string = this.ssoService.getEnvironmentFromOrigin();
    return { ...sessionContext, env };
  }

  protected getAgentGroupId(): string | null {
    return this.groupService.getSelectedGroupId(true);
  }
}
